import React from "react";
import * as styles from './htmlpane.module.css';

function HtmlPane(props) {
    
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';
    let padding = (props.padding) ? props.padding : 0;
    let innerHtml = (props.html) ? props.html.code : '';

    return (
        <div className={styles.sectionHtmlPane} style={{ backgroundColor: `${bgColor}`}}>
            <div dangerouslySetInnerHTML={{__html: innerHtml}} style={{ padding: `${padding}px`}} />
        </div>
    );
}
  
export default HtmlPane;